const resolveTextColor = (variant) => {
  switch (variant) {
    case "error":
      return "var(--figurine-feedback-error)";
    case "success":
      return "var(--figurine-feedback-success)";
    case "warning":
      return "var(--figurine-feedback-warning)";
    case "light":
      return "var(--figurine-body-white)";
    case "dark":
      return "var(--figurine-body-dark)";
    case "primary":
      return "var(--figurine-body-primary600)";
    case "alternative":
      return "var(--figurine-body-alt)";
    case "neutral":
      return "var(--figurine-body-dark200)";
    case "link":
      return "var(--figurine-links-default)";
    case "spot":
      return "var(--figurine-spot-light)";
    default:
      return "var(--figurine-body-primary600)";
  }
};
export {
  resolveTextColor
};
